import * as React from 'react'
import * as Reakit from 'reakit/Menu'

import { COMPONENT_ANIMATION_DURATION } from '../constants'

export type DropdownStateReturn = ReturnType<typeof useDropdownState>

export const DropdownContext = React.createContext<{
  parent: Reakit.MenuStateReturn
  root: Reakit.MenuStateReturn
} | null>(null)

export function useDropdownState(settings?: Reakit.MenuInitialState) {
  const context = React.useContext(DropdownContext)

  return Reakit.useMenuState({
    ...settings,
    loop: true,
    animated: COMPONENT_ANIMATION_DURATION,
    unstable_virtual: true,
    unstable_offset: settings?.unstable_offset ?? (context?.root ? [-5, 4] : [0, 5]),
    modal: false,
  })
}
